<template>
  <section class="_menu-section-style">
    <form-section label="Alinhamento" v-model="isExpanded.alignment">
      <Alignment :selectedSection="selectedSection"/>
    </form-section>

    <form-section label="Título" v-model="isExpanded.title">
      <Texts textType="title" :sectionType="selectedSection.type" :selectedSection="selectedSection"/>
    </form-section>

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts textType="text" :sectionType="selectedSection.type" :selectedSection="selectedSection"/>
    </form-section>

    <form-section label="Botão" v-model="isExpanded.button">
      <v-row no-gutters class="pb-3">
        <v-col cols="5">
          <FormAlignment v-model="selectedSection" keyValue="button-alignment"/>
        </v-col>
      </v-row>

      <draggable ghost-class="ghost" :list="selectedSection.buttons">
        <transition-group type="transition" name="list-complete">
          <div 
            v-for="(opt, index) in selectedSection.buttons" 
            :key="index" 
            class="show-cursor bgHover mb-2"
          >
            <Expansion 
              v-model="opt.show" 
              :verticalExpansion="false"
              @click="onOpen(index, opt.show)"
            > 
              <template slot="default">
                <section class="d-flex flex-column mb-2">
                  <div class="styles-item">
                    <expanded-icon :isExpanded="opt.show"/>
                    <span :style="`font-weight: ${opt.show ? '700' : '400'}`">Botão {{index + 1}}</span>
                    <div class="d-flex flex justify-end">
                      <DeleteButton @click="handleDelete(selectedSection.buttons, index)"/>       
                    </div>
                  </div>   
                </section>         
              </template>

              <template v-if="sectionsId && selectedSection.type && selectedSection.buttons[index]" slot="expanded">               
                <Buttons 
                  :sectionsId="sectionsId" 
                  :sectionType="selectedSection.type" 
                  :hasBindedStyle="hasBindedStyle" 
                  :selectedSection="selectedSection.buttons[index]"
                />
              </template>
            </Expansion>
          </div>
        </transition-group>
      </draggable>

      <v-row 
        v-if="selectedSection.buttons.length < 2" 
        class="d-flex flex-column _btn pt-6 pb-0"
        no-gutters 
      >
        <ButtonV2 
          label="Adicionar botão" 
          color="bt_gray_bg"
          textColor="darkBlue"
          textSize="0.80rem"
          icon="fa-solid fa-plus"
          @click="handleAdd"
        />      
      </v-row>      
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :minValueForNumber="0"
        @update="onUpdateBackground"
      />
    </form-section>

    <form-section label="Mídia" v-model="isExpanded.midia" :divider="false">
      <Media :selectedSection="selectedSection" />
    </form-section>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import ExpandedIcon from '../../_v2/utils/ExpandedIcon.vue'
import Expansion from '../../_v2/ui/Expansion.vue'
import ButtonV2 from '../../_v2/ui/Button.vue'
import DeleteButton from '../../_v2/ui/DeleteButton.vue'
import FormSection from '../../_v2/utils/FormSection.vue'
import FormAlignment from '../../_v2/utils/FormAlignment.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Buttons from '../forms/formsV2/Buttons.vue'
import Background from '../forms/formsV2/Background.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Media from '../forms/formsV2/Media.vue'

export default {
  name: 'ContentSection',
  components: { 
    draggable,
    ExpandedIcon,
    Expansion,
    ButtonV2,
    DeleteButton,
    FormSection, 
    Texts, 
    Buttons, 
    Background, 
    Alignment, 
    Media,
    FormAlignment
  },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  computed: {
    availableSectionsToNavigate () {
      return this.sectionsId.filter(item => !['menu', 'footer'].includes(item.title))
    },

    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    }    
  },

  data: () => ({
    isExpanded: {alignment: true, title: true, text: true, button: true, bg: true, midia: true}    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    onUpdateLogo ($event) {
      this.selectedSection['logo'] = $event['logo']
    },

    onOpen (index, state) {
      if (state && this.selectedSection.buttons && this.selectedSection.buttons.length > 0) {
        this.selectedSection.buttons.forEach((option, i) => {
          if (i !== index) option.show = false
        })
      }
    },     

    handleAdd () {
      this.selectedSection.buttons.forEach(btn => { btn.show = false })

      const newOption = {
        action: '',
        caption: `Botão ${this.selectedSection.buttons.length + 1}`,
        color: '',
        'background-color': '',
        'border-radius': '',
        show: true
      }
      this.selectedSection.buttons.push(newOption)
    },

    handleDelete(options, index) {
      options.splice(index, 1)
    }    
  }    
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move !important;
}

  .styles-item {
    display: flex;
    gap: 10px;
    height: 50px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding: 0 8px 0 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    cursor: pointer;
    animation: changeCursor 3s forwards;
  }

  .show-cursor {
    cursor: move !important;
    transition: all 0.3s;    
  }

  .show-cursor:hover {
    border-radius: 4px;
  }

  .bgHover:hover {
    background-color: #FAFBFB;    
  }

  @keyframes changeCursor {
    100% {
      cursor: move;
    }
  }

.list-complete-item {
  transition: all 0.8s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-complete-leave-active {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
</style>